// extracted by mini-css-extract-plugin
export var experts = "style-module--experts--90823";
export var experts__item = "style-module--experts__item--263ab";
export var experts__list = "style-module--experts__list--cd220";
export var experts__title = "style-module--experts__title--f3ab6";